export { Video } from './video.component';
